import DropDown from "@components/dropDown";
import Range from "@components/Range";
import {
  resetFilters,
  setFilterList,
  setFilterQuery,
  setPrice,
} from "@store/reducers/search";
import Search from "assets/svg/search.svg";
import { Button } from "components";
import debounce from "lodash/debounce";
import React, { FC, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { commafy } from "src/utils";

type Props = {
  submit: any;
  data: any;
};

export const list_status = [
  { id: 0, name: "حضوری" },
  { id: 1, name: "آنلاین" },
  { id: 2, name: "آفلاین" },
];

export const types = [
  { id: 0, name: "دوره (تک درس)" },
  { id: 1, name: "بسته (مجموعه از چند درس همگن)" },
];

type ItemProps = {
  list: any[];
  keyItem: string;
  data: any;
};

function isItemInArray(item: any, array: any[], type?: string) {
  return type == "courseCategoryIds"
    ? array?.some((i: any) => i.id === item.id && i.type === item.type)
    : array?.some((i: any) => i === item);
}

const returnFillClass = (arr: []) => {
  return arr?.length !== 0 ? "bg-blue-550/10 border-none" : "";
};

const RenderItems = ({ list, keyItem, data }: ItemProps) => {
  const dispatch = useDispatch();
  return (
    <>
      {list?.map(({ id, name, type }, index: number) => (
        <li key={JSON.stringify(index)} className="flex items-center">
          <label className="flex items-center rounded-none focus-within:outline-0">
            <input
              defaultChecked={
                keyItem !== "courseCategoryIds"
                  ? isItemInArray(id, data)
                  : isItemInArray({ id, type }, data, "courseCategoryIds")
              }
              onChange={(e: any) =>
                dispatch(
                  setFilterList({
                    checked: e.target.checked,
                    value: { id, type },
                    key: keyItem,
                  })
                )
              }
              type="checkbox"
              className="peer ml-[10px] h-[18px] min-w-[18px] rounded-none accent-blue-550 focus-within:outline-0 active:bg-blue-550"
            />{" "}
            <span className="whitespace-nowrap peer-checked:text-blue-550">
              {name}
            </span>
          </label>
        </li>
      ))}
    </>
  );
};

const DesktopTab: FC<Props> = ({ submit, data }) => {
  const state = useSelector((state: any) => state.search);
  const {
    entityType,
    courseType,
    fromPrice,
    toPrice,
    courseCategoryIds,
    teacherIds,
    certificateIds,
    query,
    sortBy,
  } = state;
  const [isOpenSearchInput, setIsOpenSearchInput] = useState(false);
  const dispatch = useDispatch();

  const delayedQuery = useRef(
    debounce((data) => {
      submit(data);
    }, 500)
  ).current;

  const [key, setKey] = useState(1);
  return (
    <div className="hidden flex-col md:flex">
      {isOpenSearchInput && (
        <label className="relative block animate-fade-in-down">
          <span className="absolute inset-y-0 right-0 flex items-center pr-[18px]">
            <Search />
          </span>
          <input
            type="text"
            value={query}
            name="search"
            onChange={(e: any) => {
              dispatch(setFilterQuery({ query: e.target.value }));
              delayedQuery({
                query: e.target.value,
                entityType: entityType,
                courseType: courseType,
                fromPrice,
                toPrice,
                courseCategoryIds,
                teacherIds,
                certificateIds,
                sortBy,
              });
            }}
            className="block w-full rounded-full border border-blue-550 bg-white py-2 pr-12 pl-3 text-xs text-blue-550 shadow-sm placeholder:text-blue-550 focus:border-blue-550 focus:outline-none focus:ring-1 focus:ring-blue-550 sm:text-sm md:h-[34px] lg:h-[51px]"
            placeholder="جستجو"
          />
        </label>
      )}
      <form
        key={key}
        className="grid grid-cols-6 gap-x-[10px] pt-10 md:gap-y-5 xl:grid-cols-9"
      >
        <Button
          type="button"
          onClick={(e) => {
            e.stopPropagation;
            setIsOpenSearchInput((prev) => !prev);
          }}
          className="flex items-center rounded-full bg-blue-550/10 px-5 py-2 text-sm text-blue-550 xl:text-base"
        >
          <Search className="ml-2" />
          جستجو
        </Button>
        <DropDown btnClass={returnFillClass(entityType)} title="نوع">
          <ul className="space-y-2 py-5 px-[10px]">
            <RenderItems data={entityType} keyItem="entityType" list={types} />
          </ul>
        </DropDown>
        <DropDown title="وضعیت" btnClass={returnFillClass(courseType)}>
          <ul className="w-36 space-y-2 bg-white py-5 px-[10px]">
            <RenderItems
              data={courseType}
              keyItem="courseType"
              list={list_status}
            />
          </ul>
        </DropDown>
        <DropDown title="موضوع" btnClass={returnFillClass(courseCategoryIds)}>
          <ul className="h-44 w-max space-y-2 overflow-y-auto py-5 px-[10px]">
            <RenderItems
              data={courseCategoryIds}
              keyItem="courseCategoryIds"
              list={data?.courseCategories}
            />
          </ul>
        </DropDown>
        <DropDown title="قیمت">
          <ul className="relative flex h-32 w-72 flex-col p-5">
            <div className="mb-0 flex pb-2">
              از
              <span className="mx-1">{commafy(data?.minPrice)}</span>
              تا
              <span className="mx-1">{commafy(data?.maxPrice)}</span>
              تومان
            </div>
            {data && (
              <Range
                min={data?.minPrice}
                max={data?.maxPrice}
                onChange={({ min, max }: any) =>
                  dispatch(setPrice({ min, max }))
                }
              />
            )}
          </ul>
        </DropDown>
        <DropDown title="استاد" btnClass={returnFillClass(teacherIds)}>
          <ul className="max-h-48 w-max space-y-2 overflow-y-auto py-5 px-[10px]">
            <RenderItems
              data={teacherIds}
              keyItem="teacherIds"
              list={data?.teachers}
            />
          </ul>
        </DropDown>
        <DropDown title="مدرک" btnClass={returnFillClass(certificateIds)}>
          <ul className="max-h-48 w-max space-y-2 overflow-y-auto py-5 px-[10px] 2xl:w-min">
            <RenderItems
              data={certificateIds}
              keyItem="certificateIds"
              list={data?.courseCertificate}
            />
          </ul>
        </DropDown>
        <Button
          type="button"
          onClick={() =>
            submit({
              query,
              entityType,
              courseType,
              fromPrice,
              toPrice,
              courseCategoryIds,
              teacherIds,
              certificateIds,
              sortBy,
            })
          }
          className="flex items-center whitespace-nowrap rounded-full border bg-blue-550 px-3 py-2 text-center text-sm text-white lg:text-base xl:mr-3 xl:px-5 xl:text-base"
        >
          اعمال فیلتر
        </Button>
        <Button
          onClick={() => {
            dispatch(resetFilters());
            submit({
              query: "",
              entityType: [] as any,
              courseType: [] as any,
              fromPrice: 0,
              toPrice: data?.maxPrice,
              courseCategoryIds: [],
              teacherIds: [],
              certificateIds: [],
              sortBy: 1,
            });
            setKey((prev) => prev + 1);
          }}
          type="button"
          className="whitespace-nowrap text-sm font-bold text-blue-550 xl:text-base"
        >
          حذف فیلتر
        </Button>
      </form>
    </div>
  );
};

export default DesktopTab;
